.additional-conditions-banner {
  align-items: center;
  background-color: $svs-super-light-grey;
  border: 1px solid $svs-light-grey;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 20px;

  &__button-section {
    align-self: center;
    margin-top: 0px;
    flex-shrink: 0;

    @media (max-width: 780px) {
      align-self: stretch;
      margin-top: 16px;
    }
  }

  .additional-conditions-banner__button {
    width: 100%;
  }

  strong {
    margin-right: 6px;
  }

  p {
    margin: 0;
  }

  & > div {
    display: flex;
    justify-content: space-between;
    margin-inline: auto;
    width: 100%;

    @media (max-width: 780px) {
      flex-direction: column;
    }
  }

  &-content {
    margin-right: 16px;
    display: flex;

    &__icon {
      align-self: center;
      margin-right: 12px;

      @media (max-width: 780px) {
        display: none;
        margin-right: 12px;
        place-self: baseline;
      }
    }

    &-header {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      &__title {
        font-size: 22px;
        line-height: 30px;
      }
    }

    &__subtitle {
      font-size: 16px;
      line-height: 22px;

      @media (max-width: 780px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  // Combinations
  &--guided {
    border: none;
    border-bottom: 1px solid #cac7c7;
    margin: 0;

    qds-button {
      margin-left: 20px;
      margin-right: 20px;
    }

    .additional-conditions-banner {
      &-content {
        &-header {
          display: unset;

          &__title {
            font-size: 16px;
            line-height: 25px;
          }

          &__subtitle {
            font-size: 14px;
            line-height: 20px;

            @media (max-width: 780px) {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  &--standard-tab {
    align-items: center;
    display: flex;
    margin-top: 0;

    section {
      align-items: center;
      display: flex;
    }

    @media (min-width: $uiaas-tablet) {
      margin-right: 8px;
    }

    .additional-conditions-banner-content {
      &__subtitle {
        font-size: 16px;
      }

      &__icon {
        align-items: center;
        display: flex;

        @media (max-width: 780px) {
          display: none;
          margin-right: 12px;
          place-self: baseline;
        }

        svg {
          height: 32px;
          width: 32px;
        }
      }
    }
  }
}
